import React, { forwardRef, useImperativeHandle, useState } from 'react';

import { SEARCH_FILTER_COOKIE } from 'app/constants';
import IconArrow from 'app/ui-kit/icons/KeyboardArrowRight.svg';
import useScrollTopButton from 'hooks/use-scroll-top-button';
import Footer from 'main/components/Footer';
import LoginNotification from 'pages/components/LoginNotification';
import { getCookie, setCookie } from 'utils/cookies';
import isBrowser from 'utils/is-browser';

import useStyles from './styles';

interface Props {
    main?: React.ReactNode;
    additional?: React.ReactNode;
    scrollable?: boolean;
}

const Layout: React.ForwardRefRenderFunction<{ scrollTop: () => void }, Props> = (props, ref) => {
    const { classes, cx } = useStyles();
    const { scrollTopButton, setScrollable, scrollTop } = useScrollTopButton();
    const { main, additional, scrollable } = props;

    const [additionalHidden, setAdditionalHidden] = useState(
        isBrowser() ? getCookie(SEARCH_FILTER_COOKIE) === 'true' : false
    );
    const handleHideAdditional = () => {
        setCookie(SEARCH_FILTER_COOKIE, String(!additionalHidden), {
            ['max-age']: Number.MAX_SAFE_INTEGER
        });
        setAdditionalHidden(!additionalHidden);
    };

    useImperativeHandle(ref, () => ({ scrollTop }), [scrollTop]);

    return (
        <div className={classes.container} ref={(node) => setScrollable(node?.parentElement)}>
            <div className={classes.wrapper}>
                <div className={classes.main}>{main && <div className={classes.content}>{main}</div>}</div>
                {additional && (
                    <div className={cx(classes.additional, additionalHidden && classes.additionalHidden)}>
                        <div className={classes.hideButton} onClick={handleHideAdditional}>
                            <IconArrow />
                        </div>
                        {additional}
                    </div>
                )}
            </div>
            <Footer />
            {scrollable && scrollTopButton}
            <LoginNotification />
        </div>
    );
};

Layout.displayName = 'Layout';

export default forwardRef(Layout);
